import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

const INFO = [
  {
    lbl: 'Proprietor',
    val: 'Karthikeyan.R BE\nProprietor, Muster Construct',
    icon: <><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" /></>
  },
  {
    lbl: 'Phone',
    val: '+91 80563 32329',
    icon: <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2C8 21 3 14 3 8a2 2 0 012-2z" />
  },
  {
    lbl: 'Email',
    val: 'musterconstruct@gmail.com',
    icon: <><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M2 8l10 6 10-6" /></>
  },
  {
    lbl: 'Locations',
    val: 'Salem & Coimbatore\nTamil Nadu, India',
    icon: <><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z" /><circle cx="12" cy="9" r="2.5" /></>
  },
];

export default function Contact() {
  const [form, setForm] = useState({ fn: '', ln: '', email: '', phone: '', service: '', location: '', details: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      console.error('❌ Missing EmailJS env vars. Restart the dev server after editing .env');
      setErrorMessage('Configuration error. Please contact us directly.');
      setIsSubmitting(false);
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, formRef.current, { publicKey })
      .then(
        (result) => {
          console.log('✅ Message sent successfully:', result);
          window.dispatchEvent(new Event('showToast'));
          setForm({ fn: '', ln: '', email: '', phone: '', service: '', location: '', details: '' });
          setIsSubmitting(false);
        },
        (error) => {
          console.error('❌ Failed to send. Full error object:', error);
          console.error('   status:', error?.status);
          console.error('   text:', error?.text);
          console.error('   message:', error?.message);
          const detail = error?.text || error?.message || `status ${error?.status || 'unknown'}`;
          setErrorMessage(`Failed to send: ${detail}`);
          setIsSubmitting(false);
        }
      );
  };

  const inp = {
    background: 'rgba(250,250,250,0.5)',
    border: '1px solid #1E2823',
    color: 'var(--wh)',
    fontFamily: 'var(--fb)',
    fontSize: '0.9rem',
    fontWeight: 500,
    padding: '0.75rem 1rem',
    outline: 'none',
    width: '100%',
    transition: 'border .2s',
    backdropFilter: 'blur(4px)',
  };
  const onFocus = (e) => (e.target.style.borderColor = '#1E2823');
  const onBlur = (e) => (e.target.style.borderColor = '#1E2823');
  const lbl = { fontSize: '0.75rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--muted)' };

  return (
    <section id="contact" style={{ position: 'relative', zIndex: 1, padding: '7rem 2rem', background: 'rgba(250,250,250,0.84)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <p style={{
            fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 700,
            letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1rem'
          }}>Get in Touch</p>
          <h2 style={{
            fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
            textTransform: 'uppercase', lineHeight: 1
          }}>
            Start Your <span style={{ color: 'var(--gold)' }}>Project</span>
          </h2>
        </div>

        <div className="cgrid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5rem', alignItems: 'start' }}>

          {/* Contact info */}
          <div>
            {INFO.map(({ lbl: label, val, icon }) => (
              <div key={label} className="reveal" style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
                <div style={{
                  width: 40, height: 40, border: '1px solid #1E2823',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="1.5" width="18" height="18">{icon}</svg>
                </div>
                <div>
                  <div style={{
                    fontFamily: 'var(--fh)', fontSize: '0.75rem', fontWeight: 700,
                    letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: '0.25rem'
                  }}>
                    {label}
                  </div>
                  <div style={{ fontSize: '0.95rem', color: 'var(--lt)', whiteSpace: 'pre-line', lineHeight: 1.6 }}>
                    {label === 'Phone' ? (
                      <a href="tel:+918056332329" style={{ color: 'var(--lt)', textDecoration: 'none' }}>
                        {val}
                      </a>
                    ) : label === 'Email' ? (
                      <a href="mailto:musterconstruct@gmail.com" style={{ color: 'var(--lt)', textDecoration: 'none' }}>
                        {val}
                      </a>
                    ) : val}
                  </div>
                </div>
              </div>
            ))}

            {/* Pricing callout */}
            <div className="reveal" style={{
              marginTop: '1rem', padding: '1.5rem',
              background: 'rgba(30,40,35,0.08)',
              border: '1px solid #1E2823',
            }}>
              <div style={{
                fontFamily: 'var(--fh)', fontSize: '0.75rem', fontWeight: 700,
                letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '0.5rem'
              }}>
                Pricing
              </div>
              <div style={{ fontFamily: 'var(--fh)', fontSize: '2rem', fontWeight: 800, color: 'var(--wh)', lineHeight: 1 }}>
                2.5Lakh<span style={{ fontSize: '1rem', fontWeight: 400, color: 'var(--muted)' }}> Affordable Price onwards</span>
              </div>
              <div style={{ fontSize: '0.85rem', color: 'var(--muted)', marginTop: '0.5rem', fontWeight: 500 }}>
                Starting from 2.5Lakh Affordable Price — residential, commercial, tensile, and PEB structures across Salem & Coimbatore.
              </div>
            </div>
          </div>

          {/* Form */}
          <form ref={formRef} onSubmit={handleSubmit} className="reveal" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="frow" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={lbl}>First Name</label>
                <input name="fn" style={inp} value={form.fn}
                  onChange={(e) => setForm(f => ({ ...f, fn: e.target.value }))}
                  onFocus={onFocus} onBlur={onBlur} placeholder="Karthik" required />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={lbl}>Last Name</label>
                <input name="ln" style={inp} value={form.ln}
                  onChange={(e) => setForm(f => ({ ...f, ln: e.target.value }))}
                  onFocus={onFocus} onBlur={onBlur} placeholder="Rajan" required />
              </div>
            </div>

            <div className="frow" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={lbl}>Phone</label>
                <input name="phone" type="tel" style={inp} value={form.phone}
                  onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))}
                  onFocus={onFocus} onBlur={onBlur} placeholder="+91 98765 43210" required />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={lbl}>Email</label>
                <input name="email" type="email" style={inp} value={form.email}
                  onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))}
                  onFocus={onFocus} onBlur={onBlur} placeholder="you@email.com" />
              </div>
            </div>

            <div className="frow" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={lbl}>Service Required</label>
                <select name="service" style={{ ...inp, cursor: 'pointer' }} value={form.service}
                  onChange={(e) => setForm(f => ({ ...f, service: e.target.value }))}
                  onFocus={onFocus} onBlur={onBlur}>
                  <option value="">Select a service...</option>
                  {['Residential Building', 'Commercial Building', 'Tensile Structure', 'PEB Structure', 'Project Management', 'Design & Consultancy'].map(s => (
                    <option key={s} style={{ background: 'var(--dk3)' }}>{s}</option>
                  ))}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={lbl}>Location</label>
                <select name="location" style={{ ...inp, cursor: 'pointer' }} value={form.location}
                  onChange={(e) => setForm(f => ({ ...f, location: e.target.value }))}
                  onFocus={onFocus} onBlur={onBlur}>
                  <option value="">Select location...</option>
                  <option style={{ background: 'var(--dk3)' }}>Salem</option>
                  <option style={{ background: 'var(--dk3)' }}>Coimbatore</option>
                  <option style={{ background: 'var(--dk3)' }}>Other</option>
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={lbl}>Project Details</label>
              <textarea name="details" style={{ ...inp, minHeight: 120, resize: 'vertical' }} value={form.details}
                onChange={(e) => setForm(f => ({ ...f, details: e.target.value }))}
                onFocus={onFocus} onBlur={onBlur}
                placeholder="Tell us about your project — plot size, type of construction, budget range, and timeline..." />
            </div>

            {errorMessage && (
              <div style={{ color: '#c0392b', fontSize: '0.85rem', fontWeight: 500 }}>{errorMessage}</div>
            )}

            <button type="submit" disabled={isSubmitting} style={{
              alignSelf: 'flex-start', background: 'var(--gold)', color: 'var(--dk)',
              fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 700,
              letterSpacing: '0.08em', textTransform: 'uppercase',
              padding: '0.85rem 2rem', border: 'none',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.7 : 1,
              transition: 'all .2s',
            }}
              onMouseEnter={(e) => { if (!isSubmitting) { e.currentTarget.style.background = 'var(--gold-l)'; e.currentTarget.style.transform = 'translateY(-2px)'; } }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--gold)'; e.currentTarget.style.transform = 'none'; }}>
              {isSubmitting ? 'Sending...' : 'Send Enquiry →'}
            </button>
          </form>
        </div>
      </div>
      <style>{`
        @media(max-width:900px){.cgrid{grid-template-columns:1fr!important}.frow{grid-template-columns:1fr!important}}
      `}</style>
    </section>
  );
}
